package `fun`.adaptive.cookbook

import `fun`.adaptive.resource.string.Strings
import `fun`.adaptive.resource.string.StringStoreResourceSet
import `fun`.adaptive.resource.file.FileResource

val commonMainStringsStringStore0 =
    StringStoreResourceSet(
        name = "strings",
        FileResource("/fun.adaptive.cookbook/strings/strings.avs", setOf())
    )

val Strings.and
    get() = commonMainStringsStringStore0.get(0)

val Strings.app_name
    get() = commonMainStringsStringStore0.get(1)

val Strings.by_joining
    get() = commonMainStringsStringStore0.get(2)

val Strings.collapsable
    get() = commonMainStringsStringStore0.get(3)

val Strings.fullNormal
    get() = commonMainStringsStringStore0.get(4)

val Strings.fullVariant
    get() = commonMainStringsStringStore0.get(5)

val Strings.hoverForPopup
    get() = commonMainStringsStringStore0.get(6)

val Strings.leftClickForPopup
    get() = commonMainStringsStringStore0.get(7)

val Strings.popupContent
    get() = commonMainStringsStringStore0.get(8)

val Strings.privacy_policy
    get() = commonMainStringsStringStore0.get(9)

val Strings.rightClickForPopup
    get() = commonMainStringsStringStore0.get(10)

val Strings.sleepiness
    get() = commonMainStringsStringStore0.get(11)

val Strings.snooze
    get() = commonMainStringsStringStore0.get(12)

val Strings.terms_of_service
    get() = commonMainStringsStringStore0.get(13)

val Strings.thin
    get() = commonMainStringsStringStore0.get(14)

val Strings.what_an_odd_second
    get() = commonMainStringsStringStore0.get(15)

val Strings.you_are_sleepy
    get() = commonMainStringsStringStore0.get(16)